import Vue from 'vue'
import { S, G, M, A, OccupationDict } from './types'
import { Getters, Mutations, Actions } from 'vuex'

/* -------------------------------------------------------------------------- */

const state = (): S => ({
  occupation: []
})

/* -------------------------------------------------------------------------- */

const getters: Getters<S, G> = {
  occupation: state => state.occupation,
  occupationDict: state =>
    state.occupation.reduce((dict, occupation) => {
      return Object.assign(dict, {
        [occupation.code]: occupation
      })
    }, {} as OccupationDict)
}

/* -------------------------------------------------------------------------- */

const mutations: Mutations<S, M> = {
  setOccupation: (state, occupation) => {
    state.occupation = occupation
  }
}

/* -------------------------------------------------------------------------- */

const actions: Actions<S, A, G, M> = {
  async fetch({ commit }) {
    const occupation = await Vue.$api.user.occupationList()
    commit('setOccupation', occupation)
  }
}

/* -------------------------------------------------------------------------- */

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
